import script from "./PreAutorizationsViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreAutorizationsViewPage.vue?vue&type=script&setup=true&lang=js"

import "./PreAutorizationsViewPage.vue?vue&type=style&index=0&id=649b9188&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649b9188"]])

export default __exports__